import { Injectable, signal } from '@angular/core';

export interface PassportRecord {
  id: string;
  status: 'pending' | 'outgoing' | 'completed';
  isSynced: boolean; // offline support indicator
  loadNumber?: string;
  growerName?: string;
  variety?: string;
  bulker?: string;
  haulier?: string;
  scheduledDelivery?: string;
  vendorNumber?: string;
  origin?: string;
  destination?: string;
  destinationWeighbridge?: string;
  apn?: string;
  apnName?: string;
  vendorName?: string;
  pcrChangeAlert?: boolean;
  statusName?: string;
  statusCode?: string;  // Backend status code
  dueDateTime?: string;
  hasDraft?: boolean;
  tabCategory?: 'load' | 'shunting' | 'transloading' | 'receiving' | 'transferred';  // For Scheduler/Gatehouse tab filtering
  transferFlag?: boolean;
}

@Injectable({ providedIn: 'root' })
export class PassportService {
  readonly records = signal<PassportRecord[]>([]);
  readonly statusFilter = signal<'pending' | 'outgoing' | 'completed'>('pending');

  /**
   * TrackBy function for *ngFor loops
   * Used by all persona components to track passport records
   */
  static trackById(_index: number, record: PassportRecord): string {
    return record.id;
  }

  getById(id: string): PassportRecord | undefined {
    return this.records().find(r => r.id === id);
  }

  upsert(record: PassportRecord): void {
    const current = this.records();
    const idx = current.findIndex(r => r.id === record.id);
    if (idx >= 0) {
      const next = current.slice();
      next[idx] = { ...next[idx], ...record };
      this.records.set(next);
    } else {
      this.records.set([...current, record]);
    }
  }

  setStatus(id: string, status: PassportRecord['status'], isSynced: boolean): void {
    const current = this.records();
    const idx = current.findIndex(r => r.id === id);
    if (idx >= 0) {
      const next = current.slice();
      next[idx] = { ...next[idx], status, isSynced };
      this.records.set(next);
    } else {
      this.records.set([...current, { id, status, isSynced }]);
    }
  }
}


